<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { appBasic } from '@/api/api'

export default {
  name: 'App',
  mounted() {
    this.setSeoMeta()
  },
  methods: {
    async setSeoMeta() {
      try {
        const data = await appBasic()
        if (data) {
          console.log(18888, data)
          window.__appBasic = data
          window.__appSeo = {
            description: data.appDescription || '',
            keywords: data.appKeyword || '',
            title: data.appName || ''
          }
          this.applySeo(window.__appSeo)
        }
      } catch (e) {
        console.error('获取SEO数据失败', e)
      }
    },
    applySeo(seo) {
      document.querySelector('meta[name="description"]').setAttribute('content', seo.description)
      document.querySelector('meta[name="keywords"]').setAttribute('content', seo.keywords)
      if (seo.title) {
        document.title = seo.title
      }
    }
  }
}
</script>

<style lang="scss" src="./assets/common.scss">
</style>
